import DashboardPage from "./DashboardPage";
import CategoriesPage from "./CategoryListPage";
import ProductListPage from "./products/ProductListPage";
import ProductForm from "./products/ProductForm";
import ProfilePage from "./ProfilePage";
import SettingsPage from "./SettingsPage";
import SuppliersPage from "./supplier/SuppliersPage";
import InventoryPage from "./inventory/InventoryTransactionPage";
import PurchaseListPage from "./purchase/PurchaseListPage";
import PurchaseForm from "./purchase/PurchaseForm";
import CustomersPage from "./CustomersPage";
import SalesListPage from "./sales/SalesListPage";
import SalesForm from "./sales/SalesForm";
import SalesOrderDetailsPage from "./sales/SalesOrderDetailsPage";
import AdjustmentListPage from "./adjustment/AdjustmentListPage";
import AdjustmentForm from "./adjustment/AdjustmentForm";
import PurchaseOrderDetailsPage from "./purchase/PurchaseOrderDetailsPage";
import SupportRequestsPage from "./support/SupportRequestsPage";
import UserListPage from "./user/UserListPage";
import UserForm from "./user/UserForm";
import PlanUsagePage from "./PlanUsagePage";
import ReportsPage from "./ReportsPage";

export interface AppRoute {
  path: string;
  element: React.ReactElement;
  allowedRoles?: string[];
}

export const appRoutes: AppRoute[] = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/product/list", element: <ProductListPage /> },
  { path: "/product/create", element: <ProductForm /> },
  { path: "/product/:productId/edit", element: <ProductForm /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/category", element: <CategoriesPage /> },
  { path: "/suppliers", element: <SuppliersPage /> },
  { path: "/inventory", element: <InventoryPage /> },
  { path: "/purchase/list", element: <PurchaseListPage /> },
  { path: "/purchase/create", element: <PurchaseForm /> },
  { path: "/purchase/:purchaseId/edit", element: <PurchaseForm /> },
  {
    path: "/purchase/:orderId",
    element: <PurchaseOrderDetailsPage />,
  },
  { path: "/customers", element: <CustomersPage /> },
  { path: "/support", element: <SupportRequestsPage /> },
  { path: "/plan-usage", element: <PlanUsagePage /> },
  { path: "/reports", element: <ReportsPage /> },
  { path: "/users", element: <UserListPage /> },
  { path: "/user/list", element: <UserListPage /> },
  { path: "/user/create", element: <UserForm /> },
  { path: "/user/:userId/edit", element: <UserForm /> },
  { path: "/sale/list", element: <SalesListPage /> },
  { path: "/sale/create", element: <SalesForm /> },
  { path: "/sale/:saleId/edit", element: <SalesForm /> },
  { path: "/sale/:orderId", element: <SalesOrderDetailsPage /> },
  { path: "/adjustment/list", element: <AdjustmentListPage /> },
  { path: "/adjustment/create", element: <AdjustmentForm /> },
  { path: "/adjustment/:adjustmentId/edit", element: <AdjustmentForm /> },
];
